import { ChangeEvent, useEffect, useRef, useState } from "react"
import { postFile, transformToFormdata } from "../../../../api/uploadFile/services"
import useAppAuth from "../../../providers/AppAuthProvider/hooks/useAppAuth"
import { Step1FormProps, useStep1FileHandleProps } from "../types"

const useStep1FileHandling = (form: Step1FormProps['form']): useStep1FileHandleProps => {

    const auth = useAppAuth()
    const [fileData, setFileData] = useState<FileList | null>(null)
    const [resultMessage, setResultMessage] = useState<string | undefined>(undefined)
    const [fileExtension, setFileExtension] = useState<string | undefined>()

    const fileRef = useRef<HTMLInputElement>(null)
    const acceptedExtensions = ['pdf', 'jpg', 'jpeg', undefined]
    const includesUnaccepted = !acceptedExtensions.includes(fileExtension || undefined)
    const showFileError = resultMessage && includesUnaccepted

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) =>
    {
        const { files } = e.target
        form.setValue('uploadedFile', true)
        setFileData(files)
        files && setFileExtension(files[0]?.name.split('.').pop())
    }

    useEffect(() => {
        async function sendFile() {
            if (fileData !== null && fileData[0]) {
                setResultMessage(undefined)
                var result = await postFile(transformToFormdata(fileData), auth.synonym)
                if (result) setResultMessage(result)
            }
        }
        sendFile()
    }, [auth.synonym, fileData])

    return {
        fileData,
        setFileData,
        resultMessage,
        fileRef,
        handleFileChange,
        showFileError
    }
}

export default useStep1FileHandling